import React from 'react';
import PriceFilter from "../features/priceFilters/components/PriceFilter";
import DurationFilter from "../features/departureTimeFilters/components/DurationFilter";
import DepartureTimeFilters
    from "@SearchResults/features/sidebar/features/departureTimeFilters/components/DepartureTimeFilters";
import CompanyFilters from "@SearchResults/features/sidebar/features/companyFilters/components/CompanyFilters";
import {SearchResultsRtkQueryResponseType} from "@SearchResults/api/types/SearchResultsRtkQueryResponse.type";
import StationFilters from "@SearchResults/features/sidebar/features/stationFilters/components/StationFilters";
import PopularFilters from "@SearchResults/features/sidebar/features/popularFilters/components/PopularFilters";
import ParamsType from "@SearchResults/types/params/Params.type";

type FiltersProps = {
    searchData: SearchResultsRtkQueryResponseType
    params: ParamsType
}

function Filters({searchData, params}: FiltersProps) {
    return (
        <>
            <PopularFilters
                searchData={searchData}
                params={params}
            />
            <PriceFilter/>
            <DurationFilter/>
            <DepartureTimeFilters/>
            <CompanyFilters
                searchData={searchData}
                params={params}
            />
            <StationFilters
                searchData={searchData}
                params={params}
            />
        </>
    );
}

export default Filters;